export const DONE_BUTTON_TEXT = "Done";
export const DESKTOP_CALENDAR_TITLE =
  "Select the check-in and check-out dates for your stay";
export const SEARCH_BUTTON_TEXT = "Search";